import { payorSearch } from "@/api/search.service";
export const usePayorSearch = () => {
  const itemTitle = i => i.name;
  return {
    itemTitle,
    comparisonValue: v => `${v.id}-${v.type}`,
    fetchResults: async v => {
      const res = await payorSearch(v);
      const items = res.data.payors;
      return items.toSorted((a, b) => itemTitle(a).localeCompare(itemTitle(b)));
    }
  };
};
